import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import {
  TCHCompatibleLoadersFields,
  TCHCompatibleLoadersProps,
  TCHCompatibleLoadersItem,
} from '../types/contentHubCompatibleLoaders.types';
import { StringField } from '../../../types/types';
export class ContentHubCompatibleLoadersModel {
  private readonly fields: TCHCompatibleLoadersFields;
  private readonly rendering?: ComponentRendering;

  constructor(props: TCHCompatibleLoadersProps) {
    this.fields = props?.fields;
    this.rendering = props?.rendering;
  }

  get thumbnailEE(): string {
    return this.fields?.itemData?.thumbnail || '';
  }

  get componentName(): string {
    return this.rendering?.componentName || '';
  }

  get title(): StringField | undefined {
    return this.fields?.itemData?.fields?.titleAndDescription?.title;
  }

  get description(): StringField | undefined {
    return this.fields?.itemData?.fields?.titleAndDescription?.description;
  }

  get items(): TCHCompatibleLoadersItem[] {
    return this.fields?.apiData?.items || [];
  }

  get baseUrl(): string {
    return this.fields?.itemData?.fields?.productsItemUrl ?? '';
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }
}
